// extracted by mini-css-extract-plugin
export default {"giftContainer":"Gift_giftContainer__1s140","giftImage":"Gift_giftImage__KN0Jb","title":"Gift_title__wXSBl","description":"Gift_description__VQDOU"};